/* TD UX-COLL 2026-10-11 — design idea #17 (Felix 11.10.2026): the filter drawer button shows the result count
   („29 Produkte anzeigen“) and updates it while filters are changed in the drawer, before they are applied.
   How: on every change inside <facets-drawer>, the same URL that Prestige's facets-form builds (form action + form data +
   section_id) is fetched; the section carries data-td-count="<number of products>". Templates for the label are in
   data-td-one / data-td-other / data-td-none on [data-td-apply-label] (snippets/td-ux-coll-apply-label.liquid).
   No count in the response or a network error → the label simply stays as it is. Works after Prestige re-renders the
   section (document-level listener).
   TD Codex R1 (11.10.2026): the search section also says which wording its count belongs to (data-td-count-kind =
   products | results, sections/main-search.liquid) and its label carries both template sets (data-td-p-* / data-td-r-*):
   the fetched count is written with the wording of that response — the facets form sends no ?type=, so a product-only
   search can turn into a mixed one. Collections send no kind: unchanged. */
(function () {
  if (window.tdUxCollInit) return;
  window.tdUxCollInit = true;

  var controller = null;
  var timer = null;

  function format(n) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined).format(n);
    } catch (e) {
      return String(n);
    }
  }

  function setLabel(label, n, kind) {
    var pre = kind === 'products' ? 'data-td-p-' : (kind === 'results' ? 'data-td-r-' : 'data-td-');
    var name = n === 0 ? 'none' : (n === 1 ? 'one' : 'other');
    var tpl = label.getAttribute(pre + name) || label.getAttribute('data-td-' + name);
    if (tpl) label.textContent = tpl.replace('{count}', format(n));
  }

  function update(form) {
    var drawer = form.closest('facets-drawer');
    var facets = form.closest('facets-form');
    if (!drawer || !facets) return;
    var label = drawer.querySelector('[data-td-apply-label]');
    if (!label) return;

    var url = new URL(form.action, window.location.href);
    url.search = '';
    new FormData(form).forEach(function (value, key) {
      url.searchParams.append(key, value);
    });
    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach(function (key) {
      if (url.searchParams.get(key) === '') url.searchParams.delete(key);
    });
    url.searchParams.set('section_id', facets.getAttribute('section-id'));

    if (controller) controller.abort();
    controller = new AbortController();
    label.setAttribute('aria-busy', 'true');

    fetch(url.toString(), { signal: controller.signal, credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        var match = html && html.match(/data-td-count="(\d+)"/);
        var kind = html && html.match(/data-td-count-kind="(products|results)"/);
        if (match) setLabel(label, parseInt(match[1], 10), kind ? kind[1] : '');
      })
      .catch(function () {})
      .then(function () { label.removeAttribute('aria-busy'); });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var form = target.closest('facets-drawer facets-form form');
    if (!form) return;
    clearTimeout(timer);
    timer = setTimeout(function () { update(form); }, 250);
  });
})();
